<template>
  <ListboxOption
      :value="option.value"
      v-slot="{ active, selected }"
  >
    <div
        :class="{
                    'bg-blue-600 text-white': active,
                    'bg-white text-black': !active,
                    }"
        class="flex items-center cursor-pointer pr-6"
    >
      <CheckIcon class="w-6 h-6 mx-1" v-show="selected" />
      <div class="w-6 h-6 mx-1" v-show="!selected"></div>
      <slot :active="active" :selected="selected">
        <span>{{ option.label }}</span>
      </slot>
    </div>
  </ListboxOption>
</template>

<script setup>

import { CheckIcon } from '@heroicons/vue/solid';
import { ListboxOption } from '@headlessui/vue';

defineProps({
  option: {
    type: Object,
    required: true
  }
});

</script>
